import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/index.vue";
import appRoutes from "../views/router.js";
import { TokenService } from "../services/storage"
import store from "../store"
import moment from 'moment';

const routes = [
  {
    path: "/",
    name: "Home",
    children: appRoutes,
    component: Home,
    meta: {
      title: "Home",
    },
  },
  {
    path: "/login",
    name: "Login",
    meta: {
      title: "Login",
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/auth/Login.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.title);

  const previousNearestWithMeta = from.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if (nearestWithTitle) {
    document.title =
      process.env.VUE_APP_TITLE + " - " + nearestWithTitle.meta.title;
  } else if (previousNearestWithMeta) {
    document.title =
      process.env.VUE_APP_TITLE + " - " + previousNearestWithMeta.meta.title;
  }

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll("[data-vue-router-controlled]")).map(
    (el) => el.parentNode.removeChild(el)
  );

  next();
});

router.beforeEach(async(to, from, next) => {
  const isAuthenticated = localStorage.access_token;
  if (to.name !== "Login" && !isAuthenticated) {
    next({ name: "Login" });
  } else {
    const token = TokenService.getToken();
    const parseJwt = (token) => {
      try {
        return JSON.parse(atob(token.split(".")[1]));
      } catch (e) {
        return null;
      }
    };

    const decodedJwt = parseJwt(token);

    if(decodedJwt?.exp){
      // console.log({
      //   decodedJwt, 
      //   a : moment(Date.now()).format('YYYY-MM-DD : HH:mm:ss'), 
      //   b: moment(decodedJwt.exp * 1000).format('YYYY-MM-DD : HH:mm:ss') 
      // })
      if (decodedJwt.exp * 1000 < Date.now()) {
        if (process.env.VUE_APP_ENABLE_GOOGLE_LOGIN == 'true') {
          await store.dispatch("googleLogout", {})
        }
        localStorage.access_token = "";
        next("/login?expired=true");
        return
      }
    }

    if(to.name == "Login" && token){
      next("/");
      return
    }
    next();
  }
});

export default router;
